<template>
  <transition name="popup">
  <div
    class  ="popup"
    :class ="{ closeTimerActive: closeTimer !== null }"
    v-if   ="visible"
    :style ="styleObject"
    @mouseleave="setCloseTimer"
    @mouseenter="cancelClose"
    @click.right.prevent
  >
    <div class="popup-title">{{name}}</div>
    <component
      :is    ="data.type"
      :data  ="data"
      @close ="popupClose"
    />
  </div>
  </transition>
</template>

<script lang="">
import Icon from './icon'
import Test from './test'

export default {
  // Options / Data
  data () {
    return {
      id         : null,
      visible    : false,
      closeTimer : null,
      name       : 'fafafa',
      data       : {
        type : 'test',
        name : 'aaa',
        top  : 0,
        left : 0
      }
    }
  },
  computed: {
    styleObject () {
      return {
        top  : this.data.top + 40 + 'px',
        left : this.data.left - 40 + 'px'
      }
    }
  },
  methods: {
    setCloseTimer () { this.closeTimer = setTimeout(() => { this.popupClose() }, 10000) },
    cancelClose () {
      clearTimeout(this.closeTimer)
      this.closeTimer = null
    },
    popupClose () {
      this.visible = false
      this.id   = null
      this.name = ''
      this.data = null
    }
  },
  created () {
    this.$eventHub.$on('popup', (data, name, id) => {
      if (this.id === id) { return this.popupClose() }
      this.id      = id
      this.data    = data
      this.name    = name
      this.visible = true
    })
  },
  // watch: {},
  // Options / DOM
  // el () {},
  // replace: true,
  // template: '',
  // Options / Lifecycle Hooks
  // init () {},
  // crated () {},
  // beforeCompile () {},
  // compiled () {},
  // ready () {},
  // attached () {},
  // detached () {},
  // beforeDestroy () {},
  // destroyed () {},
  // Options / Assets
  // directives: {},
  // elementDirectives: {},
  // filters: {},
  components: {
    Icon,
    Test
  }
  // transitions: {},
  // partials: {},
  // Options / Misc
  // parent: null,
  // events: {},
  // mixins: [],
  // name: ''
}
</script>

<style scoped>
.popup {
  position         : fixed;
  z-index          : 600;
  background-color : silver;
}

.popup-title {
  width            : 100%;
  background-color : gray;
}

.closeTimerActive {
  opacity             : 0.9;
}

.popup-enter-active {
  animation: open-popup .5s;
}
.popup-leave-active {
  animation: close-popup .4s;
}

@keyframes open-popup {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes close-popup {
  100% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup-window/index.vue